<script setup>
defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true,
    },
    texto: {
        type: String,
        required: true,
    },
    blocked: {
        type: Boolean,
        default: false
    }
});

defineEmits(["update:modelValue"]);
</script>

<template>
    <div v-bind="$attrs" class="comp-toogle"
        @click.prevent="!blocked ? $emit('update:modelValue', modelValue ? false : true) : ''">
        <button :class="['toogle bg-gray-400', { 'bg-green-500': modelValue }]">
            <span :class="{
                'translate-x-full': modelValue,
                'translate-x-0': !modelValue,
            }"></span>
        </button>
        <div :class="['text-gray-400', { 'text-green-500': modelValue }]">
            {{ texto }}
        </div>
    </div>
</template>

<style>
button:focus {
    outline: none;
}
</style>
